/**
 * Mapa de tradução para erros do Supabase Auth
 */
export const translateAuthError = (message: string): string => {
  if (!message) return "Não foi possível concluir. Tente novamente.";

  const errors: Record<string, string> = {
    "Password should be at least 8 characters": "A senha precisa ter pelo menos 8 caracteres.",
    "User already registered": "Este e-mail já tem uma conta. Tente entrar ou recuperar a senha.",
    "Invalid login credentials": "E-mail ou senha incorretos.",
    "Email not confirmed": "Confirme seu e-mail antes de entrar.",
    "Unable to validate email address: invalid format": "E-mail inválido.",
    "For security purposes, you can only request this after": "Aguarde alguns segundos antes de tentar de novo.",
    "Email rate limit exceeded": "Muitas tentativas. Tente novamente em alguns minutos.",
  };

  // Busca por correspondência parcial para mensagens com variáveis (como segundos)
  for (const [key, value] of Object.entries(errors)) {
    if (message.includes(key)) {
      return value;
    }
  }

  console.error("Erro de autenticação não mapeado:", message);
  return "Não foi possível concluir. Tente novamente.";
};
